var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoTentoscap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 330.34 79.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, " .cls-1 { fill: #fff; } "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_331",
    "data-name": "Grupo 331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_329",
    "data-name": "Grupo 329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_356",
    "data-name": "Caminho 356",
    className: "cls-1",
    d: "M120.63,59.59c-1.63,1.16-3.6,1.75-5.6,1.68-5.46,0-8.58-2.89-8.58-8.4v-11.99h-4.1v-4.67h4.1v-5.69h5.83v5.69h6.67v4.67h-6.67v11.85c0,2.42,1.21,3.73,3.45,3.73,1.17,.03,2.32-.33,3.27-1.03l1.63,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_357",
    "data-name": "Caminho 357",
    className: "cls-1",
    d: "M147.82,50.36h-19.54c.7,3.64,3.73,5.97,8.07,5.97,2.54,.1,5-.88,6.76-2.71l3.12,3.59c-2.24,2.66-5.74,4.06-10.03,4.06-8.35,0-13.76-5.37-13.76-12.78s5.46-12.73,12.87-12.73,12.59,5.08,12.59,12.87c0,.47-.05,1.17-.09,1.73Zm-19.59-3.87h14.13c-.38-3.56-3.46-6.22-7.04-6.06-3.58-.13-6.66,2.5-7.09,6.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_358",
    "data-name": "Caminho 358",
    className: "cls-1",
    d: "M177.11,46.67v14.27h-5.83v-13.53c0-4.43-2.19-6.58-5.92-6.58-4.15,0-6.95,2.52-6.95,7.51v12.59h-5.83v-24.91h5.55v3.22c1.91-2.29,4.94-3.5,8.58-3.5,5.97,0,10.4,3.41,10.4,10.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_359",
    "data-name": "Caminho 359",
    className: "cls-1",
    d: "M198.57,59.59c-1.63,1.16-3.6,1.75-5.6,1.68-5.46,0-8.58-2.89-8.58-8.4v-11.99h-4.1v-4.67h4.1v-5.69h5.83v5.69h6.67v4.67h-6.67v11.85c0,2.42,1.21,3.73,3.45,3.73,1.17,.03,2.32-.33,3.27-1.03l1.63,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_360",
    "data-name": "Caminho 360",
    className: "cls-1",
    d: "M200.39,48.49c0-7.46,5.6-12.73,13.25-12.73s13.29,5.27,13.29,12.73-5.55,12.78-13.29,12.78c-7.65,0-13.25-5.32-13.25-12.78Zm20.66,0c0-4.76-3.17-7.79-7.42-7.79s-7.37,3.03-7.37,7.79,3.17,7.79,7.37,7.79,7.42-3.03,7.42-7.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_361",
    "data-name": "Caminho 361",
    className: "cls-1",
    d: "M228.75,58.47l2.24-4.43c2.61,1.6,5.61,2.46,8.68,2.47,3.69,0,5.22-1.02,5.22-2.75,0-4.76-15.39-.28-15.39-10.21,0-4.71,4.25-7.79,10.96-7.79,3.24-.06,6.44,.68,9.33,2.15l-2.24,4.43c-2.16-1.27-4.63-1.91-7.14-1.87-3.54,0-5.23,1.17-5.23,2.8,0,5.04,15.39,.56,15.39,10.31,0,4.67-4.29,7.7-11.29,7.7-4.15,0-8.3-1.22-10.54-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_362",
    "data-name": "Caminho 362",
    className: "cls-1",
    d: "M255.94,48.77c0-7.27,5.18-12.36,12.31-12.36,3.87,0,7.23,1.49,9.24,4.48l-1.73,1.26c-1.74-2.39-4.56-3.75-7.51-3.64-5.74,0-9.93,4.1-9.93,10.26s4.2,10.26,9.93,10.26c2.95,.11,5.77-1.25,7.51-3.64l1.73,1.26c-2.13,2.96-5.6,4.64-9.24,4.48-6.56,.24-12.08-4.89-12.31-11.46-.01-.3-.01-.6,0-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_363",
    "data-name": "Caminho 363",
    className: "cls-1",
    d: "M300.21,45.51v15.44h-2.24v-4.34c-1.54,2.8-4.52,4.52-8.77,4.52-5.46,0-8.77-2.8-8.77-6.95,0-3.69,2.33-6.81,9.1-6.81h8.35v-1.96c0-4.52-2.47-6.95-7.23-6.95-3.08-.03-6.07,1.06-8.4,3.08l-1.17-1.68c2.73-2.28,6.19-3.51,9.75-3.45,6.02,0,9.38,3.08,9.38,9.1Zm-2.33,8.26v-4.57h-8.3c-5.04,0-6.81,2.1-6.81,4.9,0,3.17,2.47,5.13,6.76,5.13,4.1,0,6.95-1.96,8.35-5.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_364",
    "data-name": "Caminho 364",
    className: "cls-1",
    d: "M330.34,48.77c0,7.32-5.18,12.36-12.04,12.36-4.11,.11-7.94-2.11-9.89-5.74v14.6h-2.33V36.6h2.24v5.74c1.91-3.73,5.79-6.04,9.98-5.92,6.86,0,12.04,5.09,12.04,12.36Zm-2.33,0c0-6.11-4.24-10.26-9.84-10.26s-9.79,4.15-9.79,10.26,4.2,10.26,9.79,10.26,9.84-4.15,9.84-10.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_330",
    "data-name": "Grupo 330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_365",
    "data-name": "Caminho 365",
    className: "cls-1",
    d: "M30.94,60.94h12.56l3-3h-15.56c-5.01,0-9.07-4.06-9.08-9.08V21.87h7.2l3-3h-10.2v-6.79s0-.08,0-.12h-3s0,.08,0,.12V48.87c.01,6.67,5.41,12.06,12.08,12.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_366",
    "data-name": "Caminho 366",
    className: "cls-1",
    d: "M67.73,0H30.94c-5.47,0-10.25,3.68-11.67,8.95h3.14c1.32-3.58,4.72-5.95,8.53-5.96h36.79c5.01,0,9.07,4.06,9.08,9.08V48.87c0,5.01-4.07,9.07-9.08,9.08h-6.79v-14.46h0v-12.55c0-.75-.07-1.5-.21-2.24h0c-.2-1.1-.56-2.17-1.07-3.17h0c-1.17-2.33-3.06-4.21-5.38-5.38h0c-1-.51-2.07-.87-3.17-1.08h0c-.74-.14-1.49-.21-2.24-.21h-12.54l-3,3-8.28,8.28v4.24l12.52-12.52h10.76l-23.29,23.29v3.72c0,.17,.01,.33,.03,.5l26.95-26.95h0c2.49,.93,4.45,2.89,5.38,5.38l-26.94,26.95c.16,0,.33,.03,.5,.03h3.72l23.29-23.29v10.76l-12.52,12.53h4.23l8.29-8.29v11.46h-7.2l-3,3h10.2v6.79c0,5.01-4.07,9.07-9.08,9.08H12.08c-5.01,0-9.07-4.07-9.08-9.08V30.94c0-5.01,4.07-9.07,9.08-9.08h3.79v-3s-3.79,0-3.79,0c-6.67,0-12.07,5.41-12.08,12.08v36.8c0,6.67,5.41,12.07,12.08,12.08H48.87c6.67,0,12.07-5.41,12.08-12.08v-6.79h6.79c6.67,0,12.07-5.41,12.08-12.07V12.08c0-6.67-5.42-12.08-12.09-12.08Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTentoscap);
export default __webpack_public_path__ + "static/media/logo-tentoscap.56534af29e5a8af65205cd7d194b5da1.svg";
export { ForwardRef as ReactComponent };